export default __webpack_public_path__ + "747f48d061fc62c1cc7aff2557d80333.png";